import React from 'react';
import LogoSVG from "../../img/dipartimento-protezione-civile.svg";
import SvgIconDPC from "../dpc-svg-icon";

export default class DpcFooterItAlert extends React.Component {

    constructor(props) {
        super(props);
        this.setCookie = this.setCookie.bind(this);
        this.state = {checkCookie: typeof document !== `undefined` && !document.cookie.match(/^(.*;)?\s*cookies_consent\s*=\s*[^;]+(.*)?$/)}
    }


    getDomain() {
        if (typeof window !== `undefined`) {
            const hostnameArray = window.location.hostname.split('.')
            if(hostnameArray.length === 3) {
                const numberOfSubdomains = hostnameArray.length - 2;
                return hostnameArray.length === 2 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
            } else {
                const numberOfSubdomains = hostnameArray.length - 3;
                return hostnameArray.length === 1 ? window.location.hostname : hostnameArray.slice(numberOfSubdomains).join('.')
            }
        }
    }


    setCookie(check) {
        if (typeof document !== `undefined`) {
            if (document.cookie.indexOf('cookies_consent=true') >= 0 && !check) {
                document.cookie = 'cookies_consent=; Path=/; Expires=' + new Date().toUTCString() + ';';
            }
            var date = new Date();
            date.setTime(date.getTime() + (90 * 24 * 60 * 60 * 1000));
            const expires = "; expires=" + date.toUTCString();
            document.cookie = "cookies_consent=" + (check ? "true" : "false") + expires + ";domain=" + this.getDomain() + "; path=/; SameSite=Lax";
            console.log("cookies_consent=" + (check ? "true" : "false") + expires + ";domain=" + this.getDomain() + "; path=/; SameSite=Lax");
            window.location.reload();
        }
    }

    geFooterLinkBasePath = () => {
        if (this.props.portaleUrl) {
            return `${this.props.portaleUrl}/${this.props.lang}`
        } else {
            return `/${this.props.lang}`
        }
    }

    getCookie = () => {
        if (typeof document !== `undefined`) {
            return !!document.cookie.indexOf('cookies_consent=true') >= 0;
        }
        return false;
    }

    render() {
        return (
            <>
                <footer className="it-footer" role="contentinfo" id="footer" tabIndex="-1">
                    
                    <div className="it-footer-main">
                        <div className="container">
                            <div className="px-custom">
                                    <div className="row">
                                        <div className="col-12">
                                            <img
                                            src={LogoSVG} className="logo-footer"
                                            alt="Dipartimento Protezione Civile"/>
                                            <h3>Presidenza del Consiglio dei Ministri<br/>Dipartimento della Protezione Civile</h3>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </div>
                    <div className="it-footer-sub">
                        <div className="container">
                            <div className="px-custom">
                                <div className="row">
                                    <div className="col-12">
                                        <ul className="footer-list link-list clearfix">
                                    {
                                        this.props.menuFooterItems?.sort((a, b) => {
                                            return a.weight > b.weight ? 1 : -1;
                                        }).map((item, i) => {
                                                return (                                                                                                                                                  
                                                <li className="list-inline-item"><a
                                                    href={`${this.geFooterLinkBasePath()}${item.node?.relationships?.field_link_menu?.fields?.slug}`}>{item.node?.name}</a>
                                                </li>    
                                                    
                                                )
                                            }
                                        )
                                    }
                                    {/*
                                    <li className="list-inline-item"><a
                                        href={"#"}id="ot-sdk-btn" className="ot-sdk-show-settings"></a>
                                    </li>
                                */}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                {this.state.checkCookie ?
                    <div className={`cookiebar bg-dark p-4 show`}
                         aria-hidden="true">
                        <div className="container">
                            <div className="px-custom">
                                <div className="row d-flex align-items-center">
                                    <div className="col-12 col-md-9" style={{'text-align': 'justify'}}>
                                        <span className="text-white small">
                                            {this.props.lang === 'it'
                                                ? 'Questo sito utilizza cookies tecnici, cookie analytics e cookie di terze parti (altri siti e piattaforme web) per la personalizzazione della home page, il monitoraggio delle visite al sito, la condivisione dei contenuti sui social network, la compilazione automatica di moduli e/o la visualizzazione di contenuti multimediali. Per maggiori informazioni consulta la privacy policy Acconsenti all\'utilizzo di cookie di terze parti?'
                                                : 'This website uses technical and analytical cookies, also from third parties (other websites and web platforms), for the home page customization, visitor monitoring, content sharing on social networks, automatic form filling and/or multimedia content visualization. For further information please consult the privacy policy. Do you agree to the use of third party cookies?'}
                                        </span>
                                    </div>
                                    <div className="col-12 col-md-3 mt-4 mt-md-0 d-flex justify-content-end">
                                        <a className="btn btn-link" href="#">Privacy policy</a>
                                        <button className="btn btn-primary mr-2" onClick={() => {
                                            this.setCookie(true)
                                        }}>{this.props.lang === 'it' ? 'Accetto' : 'I agree'}
                                        </button>
                                        <button className="btn btn-secondary mr-2 cookies-consent-reject"
                                                id="cookiesConsentReject" onClick={() => {
                                            this.setCookie(false)
                                        }}>{this.props.lang === 'it' ? 'Rifiuto' :  'I do not agree'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                                    </div> : null}
            </>)
    }

}
